import { GPSTrackingDeviceMetadata, MobileAppMetadata } from './device-metadata.interface';
import { TachographDecodedDataInput } from './tachograph-decoded-data-input.interface';

export interface PositionMessage {
    latitude: string;
    longitude: string;
    speed: number;
    reportedAt: string; // Date when the position was reported by the device in UTC (YYYY-MM-DD HH:MM:SS)
    heading: number;
}

export interface DecodedTrackerPositionMessage extends PositionMessage, GPSTrackingDeviceMetadata {
    code: string;
    licensePlate: string;
    ignition?: boolean;
    satelliteCount?: number;
    processedAt: string;
    tachographData?: TachographDecodedDataInput;
}

export interface MobilePositionMessage extends PositionMessage, MobileAppMetadata {
    phoneNumber: string;
    osVersion?: string;
    appVersion?: string;
    accuracy?: number; // in meters
    speedAccuracy?: number;
    time?: string; // timestamp unix
}
